import {
  TODO_LIST_DATE_FILTER_KEY,
  TODO_LIST_EMPLOYEE_FILTER_KEY,
} from "views/app-views/MainDashboard/DailyNotes/constants";
import {
  FUNNEL_FILTER_TYPE,
  SELECTED_PIPELINE,
  SELECTED_RANGE,
} from "./FunnelConstant";
import {
  SMS_TEMPLATE_VIEW_MODE_KEY,
  EMAIL_TEMPLATE_VIEW_MODE_KEY,
} from "./TemplateFolderConstant";

export const FIRST_PAGE = 1;
export const TABLE_ACTION_SORT = "sort";
export const TABLE_ACTION_FILTER = "filter";
export const PER_PAGE_10 = 10;
export const PER_PAGE_30 = 30;
export const PER_PAGE_5 = 5;
export const CREATED_AT_SORT = "-created_at";

export const KEYS_TO_KEEP_ON_LOGOUT = [
  SELECTED_RANGE,
  FUNNEL_FILTER_TYPE,
  SELECTED_PIPELINE,
  SMS_TEMPLATE_VIEW_MODE_KEY,
  EMAIL_TEMPLATE_VIEW_MODE_KEY,
];

export const KEY_PREFIXES_TO_KEEP_ON_LOGOUT = [
  `${TODO_LIST_DATE_FILTER_KEY}:`,
  `${TODO_LIST_EMPLOYEE_FILTER_KEY}:`,
];
